export enum Roles {
  Merchant = 'merchant',
  Customer = 'customer'
}

export enum UserRoles {
  MerchantRetail = 'merchant_retail',
  MerchantAdmin = 'merchant_admin'
}
